// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
  INSIGHTS: '/insights',
};

// ----------------------------------------------------------------------

export const paths = {
  // AUTH
  auth: {
    signIn: `${ROOTS.AUTH}/sign-in`,
    verify: `${ROOTS.AUTH}/verify`,
    signUp: `${ROOTS.AUTH}/sign-up`,
    resetPassword: `${ROOTS.AUTH}/reset-password`,
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    reports: {
      root: `${ROOTS.DASHBOARD}/reports`,
    },
    iam: {
      root: `${ROOTS.DASHBOARD}/iam`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/iam/${id}/edit`,
      newManager: `${ROOTS.DASHBOARD}/iam/new-manager`,
    },
    locations: {
      root: `${ROOTS.DASHBOARD}/locations`,
      newLocation: `${ROOTS.DASHBOARD}/locations/new-location`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/locations/${id}/edit`,
    },
    orders: {
      root: `${ROOTS.DASHBOARD}/orders`,
      newOrder: `${ROOTS.DASHBOARD}/orders/new-order`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/orders/${id}`,
    },
    customers: {
      root: `${ROOTS.DASHBOARD}/customers`,
      newCustomer: `${ROOTS.DASHBOARD}/customers/new-customer`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/customers/${id}/edit`,
      customer: (id: string) => ({
        root: `${ROOTS.DASHBOARD}/customers/${id}`,
        transactions: `${ROOTS.DASHBOARD}/customers/${id}/transactions`,
        giftCards: `${ROOTS.DASHBOARD}/customers/${id}/gift-cards`,
        notes: `${ROOTS.DASHBOARD}/customers/${id}/notes`,
        events: `${ROOTS.DASHBOARD}/customers/${id}/events`,
        pushNotifications: `${ROOTS.DASHBOARD}/customers/${id}/push-notifications`,
      }),
    },
    products: {
      root: `${ROOTS.DASHBOARD}/products`,
      stockConflicts: `${ROOTS.DASHBOARD}/products/stock-conflicts`,
      manageStock: `${ROOTS.DASHBOARD}/products/manage-stock`,
      manageProductSettings: `${ROOTS.DASHBOARD}/products/manage-product-settings`,
      newProduct: `${ROOTS.DASHBOARD}/products/new-product`,
      product: (id: string) => `${ROOTS.DASHBOARD}/products/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/products/${id}/edit`,
    },
    modifiers: {
      root: `${ROOTS.DASHBOARD}/modifiers`,
      newModifier: `${ROOTS.DASHBOARD}/modifiers/new-modifier`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/modifiers/${id}/edit`,
    },
    globalModifiers: {
      root: `${ROOTS.DASHBOARD}/global-modifiers`,
      newModifier: `${ROOTS.DASHBOARD}/global-modifiers/new-modifier`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/global-modifiers/${id}/edit`,
    },
    categories: {
      root: `${ROOTS.DASHBOARD}/categories`,
      mainCategories: `${ROOTS.DASHBOARD}/categories/main-categories`,
      subCategories: `${ROOTS.DASHBOARD}/categories/sub-categories`,
    },
    giftcards: {
      root: `${ROOTS.DASHBOARD}/giftcards`,
      manageGiftCardVariants: `${ROOTS.DASHBOARD}/giftcards/manage-gift-card-variants`,
      view: (id: string) => `${ROOTS.DASHBOARD}/giftcards/${id}`,
    },
    balanceTransfers: {
      root: `${ROOTS.DASHBOARD}/balance-transfers`,
      view: (id: string) => `${ROOTS.DASHBOARD}/balance-transfers/${id}`,
    },
    rewards: {
      root: `${ROOTS.DASHBOARD}/rewards`,
    },
    offers: {
      root: `${ROOTS.DASHBOARD}/offers`,
    },
    events: {
      root: `${ROOTS.DASHBOARD}/events`,
      new: `${ROOTS.DASHBOARD}/events/new`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/events/${id}/edit`,
      notifications: (id: string) => `${ROOTS.DASHBOARD}/events/${id}/notifications`,
    },
    notifications: {
      root: `${ROOTS.DASHBOARD}/notifications`,
    },
    announcements: {
      root: `${ROOTS.DASHBOARD}/announcements`,
    },
    promos: {
      root: `${ROOTS.DASHBOARD}/promos`,
      notifications: (id: string) => `${ROOTS.DASHBOARD}/promos/${id}/notifications`,
    },
    vouchers: {
      root: `${ROOTS.DASHBOARD}/vouchers`,
      new: `${ROOTS.DASHBOARD}/vouchers/new`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/vouchers/${id}/edit`,
    },
    productTags: {
      root: `${ROOTS.DASHBOARD}/product-tags`,
    },
    appSettings: {
      root: `${ROOTS.DASHBOARD}/app-settings`,
      homeSettings: `${ROOTS.DASHBOARD}/app-settings/home-settings`,
      productSettings: `${ROOTS.DASHBOARD}/app-settings/product-settings`,
      sortingConfig: `${ROOTS.DASHBOARD}/app-settings/sorting-config`,
      upsellConfig: `${ROOTS.DASHBOARD}/app-settings/upsell-config`,
      appAvailability: `${ROOTS.DASHBOARD}/app-settings/app-availability`,
    },
    feedback: {
      root: `${ROOTS.DASHBOARD}/feedback`,
    },
    syncAccount: {
      root: `${ROOTS.DASHBOARD}/sync-account`,
    },
  },
  insights: {
    root: ROOTS.INSIGHTS,
    customers: {
      root: `${ROOTS.INSIGHTS}/customers`,
      repeatRates: `${ROOTS.INSIGHTS}/customers/repeat-rates`,
      trafficSummary: `${ROOTS.INSIGHTS}/customers/traffic-summary`,
      activeUsers: `${ROOTS.INSIGHTS}/customers/active-users`,
      avgMonthlyFrequency: `${ROOTS.INSIGHTS}/customers/avg-monthly-frequency`,
      repeatCustomersWithinXDays: `${ROOTS.INSIGHTS}/customers/repeat-customers-within-x-days`,
      averageLTV: `${ROOTS.INSIGHTS}/customers/average-ltv`,
      promoSignUpStats: `${ROOTS.INSIGHTS}/customers/promo-signup-stats`,
    },
    products: {
      root: `${ROOTS.INSIGHTS}/products`,
      coOccurrence: `${ROOTS.INSIGHTS}/products/co-occurrence`,
    },
    categories: {
      root: `${ROOTS.INSIGHTS}/categories`,
    },
    stores: {
      root: `${ROOTS.INSIGHTS}/stores`,
    },
    promotions: {
      root: `${ROOTS.INSIGHTS}/promotions`,
    },
  },
};
